module.exports = __webpack_public_path__ + "static/img/discord.dcde648.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bootcamp/enroll/after-bootcamp/pengu/discord/discord.png
// module id = egPj
// module chunks = 35